import React from 'react';
import ReactDOM from 'react-dom';
import './style/index.css';
import App from './component/App';
import registerServiceWorker from './registerServiceWorker';
import thunk from 'redux-thunk';
import {applyMiddleware, compose, createStore} from 'redux';
import {rootReducer} from './state/reducer/rootReducer';
import {Provider} from 'react-redux';
import createHistory from 'history/createBrowserHistory';
import {ConnectedRouter, routerMiddleware} from 'react-router-redux';
import ErrorBoundary from "./component/alert/ErrorBoundary";

const composeEnhancers =
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;

const history = createHistory();
const middleware = [
    thunk,
    routerMiddleware(history)
];

const enhancers = composeEnhancers(applyMiddleware(...middleware));

const store = createStore(rootReducer, enhancers);

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <ErrorBoundary>
                <App/>
            </ErrorBoundary>
        </ConnectedRouter>
    </Provider>
    , document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js